
export default {
  altitudePreview: {
    expandAltitudeChart: 'Expandir gráfico',
    altitude: 'Altitude'
  }
}
